import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part12',
  templateUrl: './part12.component.html',
  styleUrls: ['./part12.component.scss']
})
export class Part12Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
